import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Card, Flex, Form } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext, PathContextProvider } from "../../context/PathContext";
import { ConfigInputProps } from "../../types/Config";
import { MetaFieldConfig } from "./meta/MetaFieldConfig";

type Props = {} & ConfigInputProps<"meta">;

export const MetaConfigInput = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <Card
      title={t("maintenance:ticket.creation.config.form.field.meta.title")}
      size="small"
      style={{ marginTop: 48, background: "#00000011" }}
    >
      <Form.List name={[...path, "fields"]}>
        {(fields, { add, remove }) => (
          <Flex vertical gap="small">
            {fields.map(({ key, name }) => (
              <PathContextProvider value={[name]} key={key}>
                <Card
                  size="small"
                  style={{ width: "100%" }}
                  actions={[
                    <Button
                      onClick={() => remove(name)}
                      danger
                      variant="text"
                      key="delete"
                    >
                      <Icon icon="fa:trash" />
                    </Button>,
                  ]}
                >
                  <Flex justify="space-between">
                    <MetaFieldConfig index={name} />
                  </Flex>
                </Card>
              </PathContextProvider>
            ))}
            <Button
              onClick={() => add()}
              style={{ width: "100%" }}
              variant="dashed"
            >
              <Icon icon="fa:plus" />
            </Button>
          </Flex>
        )}
      </Form.List>
    </Card>
  );
});
